import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { COUNTRIES_FEATURE_KEY, VOIVODESHIP_FEATURE_KEY } from './keys';
import { countriesReducer } from './reducers/countries-list.reducer';
import { voivodeshipReducer } from './reducers/voivodeship-list.reducer';
import { CountriesListEffects } from './effects/countries-list.effects';
import { VoivodeshipListEffects } from './effects/voivodeship-list.effects';

export function provideDictionariesStore(): EnvironmentProviders[] {
    return [
        provideState(COUNTRIES_FEATURE_KEY, countriesReducer),
        provideState(VOIVODESHIP_FEATURE_KEY, voivodeshipReducer),
        provideEffects(CountriesListEffects, VoivodeshipListEffects),
    ];
}
